import React, { useEffect, useState } from 'react';
import Authorize from '../../../components/AuthComponent/Authorize';
import SaveButton, { SaveButtonProps } from '../../../components/Buttons/SaveButton';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import ButtonBar from '../../../components/Fields/ButtonBar';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import { ApplicationFunctions } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import PriceModel from '../../../models/PriceModel';
import DataService from "../../../services/data.service";
import { LicenseProps } from '../../../types/IdProps';
import { Result } from '../../../types/Result';

const License_tab_RoyaltyRates: React.FC<LicenseProps> = ({ licenseId }) => {
    const [data, setData] = useState<PriceModel[]>();
    const [serverErrors, setServerErrors] = useState<Result[]>();
    const { handleResult, handleException } = useNotifications();
    const businessPartners = useSelectListOptions('api/v1/selectlist/BusinessPartnersForItem?itemId=' + licenseId, '-- Select business-partner');
    const currencies = useSelectListOptions('api/v1/selectlist/CurrencySymbols', '-- Select currency');
    const incoTerms = useSelectListOptions('api/v1/selectlist/IncoTerms', '-- Select incoterms');

    useEffect(() => {
        getTableData();
    }, [licenseId]);

    function getTableData() {
        DataService.get<PriceModel[]>('api/v1/RoyaltyRates/ByLicense/' + licenseId)
            .then(response => {
                setData(response);
                console.log('Data:', response)
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/RoyaltyRates/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function onCellChange(value: any, rowIndex: number, dataProp?: string) {
        if (data && dataProp) {
            dataProp.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    object[propertyName] = value;
                    setData(data.slice());
                }

                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, data[rowIndex]);
        }
    }

    function SaveChanges() {
        if (data) {
            DataService
                .updateTableData<PriceModel>(`api/v1/RoyaltyRates/UpdateRoyaltyRates`, data)
                .then(response => {
                    let isSuccesful = true;
                    response.forEach((result) => {
                        handleResult(result);
                        if (result.isSuccesful === false) {
                            isSuccesful = false;
                        }
                    })
                    if (isSuccesful === true) {
                        getTableData();
                    }

                    setServerErrors(response);
                })
                .catch(e => handleException(e));
        }
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Royalty type', dataProp: 'royaltyType', sort: 'asc' },
        { title: 'Rate', dataProp: 'rate', align: 'right', dataType: 'percentage', editable: true },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date', editable: true },
        { title: 'End date', dataProp: 'endDate', dataType: 'date', editable: true },
    ];

    const saveButtonProps: SaveButtonProps = {
        onClick: SaveChanges
    }

    if (businessPartners && incoTerms && currencies) {
        return (
            <>
                <DataTable
                    name='dtLicenseRoyaltyRates'
                    colInfos={colInfos}
                    tableData={data}
                    serverErrors={serverErrors}
                    onCellChange={onCellChange}
                />
                <ButtonBar offset={2}>
                    <Authorize applicationFunction={ApplicationFunctions.EditItemPrice}>
                        <SaveButton  {...saveButtonProps} />
                    </Authorize>
                </ButtonBar>
            </>
        );
    }

    return null;
}
export default License_tab_RoyaltyRates;